import { SVGWrapper } from '../SVGWrapper';

const KubernetesClusterIcon = SVGWrapper(() => {
  return (
    <svg
      width="64px"
      height="64px"
      viewBox="0 0 20 20"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      stroke="#9333ea"
      strokeWidth={0.8}
      strokeLinecap="round"
      strokeLinejoin="round">
      <title>Kubernetes Cluster</title>
      <polygon points="10,3.2 15.32,5.76 16.63,11.51 12.95,16.13 7.05,16.13 3.37,11.51 4.68,5.76" />
      <line x1="10" y1="8.3" x2="10" y2="4.3" />
      <line x1="11.33" y1="8.94" x2="14.46" y2="6.45" />
      <line x1="11.66" y1="10.38" x2="15.56" y2="11.27" />
      <line x1="10.74" y1="11.53" x2="12.47" y2="15.14" />
      <line x1="9.26" y1="11.53" x2="7.53" y2="15.14" />
      <line x1="8.34" y1="10.38" x2="4.44" y2="11.27" />
      <line x1="8.67" y1="8.94" x2="5.54" y2="6.45" />
      <circle cx="10" cy="3.8" r="0.75" />
      <circle cx="14.85" cy="6.13" r="0.75" />
      <circle cx="16.04" cy="11.38" r="0.75" />
      <circle cx="12.69" cy="15.59" r="0.75" />
      <circle cx="7.31" cy="15.59" r="0.75" />
      <circle cx="3.96" cy="11.38" r="0.75" />
      <circle cx="5.15" cy="6.13" r="0.75" />
      <circle cx="10" cy="10" r="1.7" />
    </svg>
  );
});

export default KubernetesClusterIcon;
